module.exports = __webpack_public_path__ + "media/src/img/payment/raiffaizen-logo-cffc751fd9f8c8d1f653e5da53663390.svg";